import {
    JobService,
    PolicyChangeService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';
import _, { update } from 'lodash';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { GatewayEndorsementService as EndorsementService } from 'twia-capability-gateway-policychange';
import gatewayMessages from "gw-capability-gateway-react/gateway.messages";
import messages from '../components/UnderwritingWarningComponent/UnderwritingWarningComponent.messages'
import TWIAJobHelper from './TWIAJobHelper';

const blockingUW = ['BlocksQuote', 'BlocksQuoteRelease', 'Rejected', 'BlocksOfferSubmission_Ext', 'BlocksBind', 'BlocksIssuance']
const blockSubmissionUW = ['BlocksOfferSubmission_Ext', 'BlocksBind', 'BlocksIssuance']


const premiumContinueVisibility = (uwIssues) => {
    if (!_.isUndefined(uwIssues) && !_.isEmpty(uwIssues)) {
        return !uwIssues.some((uw) => blockingUW.includes(uw.currentBlockingPoint)) // DE16924
    }

    return true
}


const checkUWIssues = (uwIssues) => {
    if (!_.isUndefined(uwIssues) && !_.isEmpty(uwIssues)) {
        return uwIssues.some((uw) => blockingUW.includes(uw.currentBlockingPoint) && !uw.hasApprovalOrRejection)
    }

    return false

};

const onWithdraw = (submissionVM, showConfirm, showAlert, translator, history, authHeader) => {
    const quoteId = submissionVM?.quoteID?.value || submissionVM?.jobID?.value
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
    const redirectPathBasedOnTransaction = isPolicyChange ? 'change' : 'quotes'
    // DE18032

    showConfirm({
        title: isPolicyChange ? messages.withdrawPolicyChangePopup : messages.withDrawJOB,
        message: isPolicyChange ? `${translator(messages.sureWithDrawPolicyChange)} ${quoteId
            }?` : `${translator(messages.sureWithDrawQuote)} ${quoteId
            }?`,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: messages.withdraw,
        cancelButtonText: messages.cancelWithdrawSubmission,
    })
        .then(results => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            JobService.withdrawJobByJobNumber(
                quoteId,
                authHeader
            ).then(
                () => {
                    //this.updateWithDrawQuote('Withdrawn', submission);
                    // eslint-disable-next-line no-param-reassign
                    submissionVM.noCancelWarning = true;
                    history.push(`${process.env.PUBLIC_PATH}/${redirectPathBasedOnTransaction}/${quoteId}/summary`)
                },
                () => {
                    showAlert({
                        title: gatewayMessages.modalError,
                        message: messages.failedWithdrawSubmission,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    })
                        .catch(_.noop);
                }
            );
        }, _.noop);
};

const onReferToUnderwriter = (submissionVM, formData, history, setShowReferToUW, showAlert, authHeader) => {
    const { uwNoteForUnderwriter } = formData;
    const noteForUW =
        uwNoteForUnderwriter === '' ? null : uwNoteForUnderwriter;
        const quoteId = submissionVM?.quoteID?.value || submissionVM?.jobID?.value
        // DE17932
        const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
        const redirectPathBasedOnTransaction = isPolicyChange ? 'change' : 'quotes'
        const serviceToUse = isPolicyChange ? PolicyChangeService : SubmissionService // DE17897,DE18035
        
        serviceToUse
        .referToUnderwriter(quoteId, noteForUW, authHeader)
        .then(
            jobResponse => {
                setShowReferToUW(false);
                // eslint-disable-next-line no-param-reassign
                submissionVM.noCancelWarning = true;
                history.push(`${process.env.PUBLIC_PATH}/${redirectPathBasedOnTransaction}/${quoteId}/summary`)
            },
            () => {
                showAlert({
                    title: gatewayMessages.modalError,
                    message: messages.errorSendingJobForReview,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);
            }
        );
}

const saveExit = (submissionVM, showConfirm, history, authHeader) => {
    // showConfirm({
    //     title: messages.TWIAWizardModalCancelTitle,
    //     message: messages.TWIAWizardModalCancelDescription,
    //     status: 'warning',
    //     icon: 'mi-error-outline',
    //     confirmButtonText: commonMessages.yesModel,
    //     cancelButtonText: commonMessages.noModel,
    // }).then((results) => {
    //     if (results === 'cancel' || results === 'close') {
    //         return _.noop();
    //     }
    // }, _.noop)

        const isStatusQuoted = _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Quoted';

        let serverCall

        if (isStatusQuoted) {
            serverCall = LoadSaveService.updateQuotedSubmission
        } else {
            serverCall = LoadSaveService.updateDraftSubmission
        }

        const payload = _.get(submissionVM, 'value')

        const quoteId = submissionVM?.quoteID?.value || submissionVM?.jobID?.value

        _.set(payload, 'bindData.paymentDetails.electronicPaymentData_TWIA', undefined);

        const jobType = _.get(submissionVM, 'baseData.jobType.value.code')
        
        let redirectPath

        if(jobType === 'PolicyChange') {
            redirectPath = `/change/${quoteId}/summary`
            EndorsementService.saveAndQuoteSubmission([payload], authHeader)
            .then(() => {
                history.push(redirectPath)
            }).catch(() => {
                history.push(redirectPath)
            })
        } else {
            redirectPath = `/quotes/${quoteId}/summary`
            serverCall(payload, authHeader)
            .then(() => {
                history.push(redirectPath)
            }).catch(() => {
                history.push(redirectPath)
            })
        }
    
}

const hasUWBlockingIssues = (uwIssues) => uwIssues.filter((uw) => blockingUW.includes(uw.currentBlockingPoint))

export default {
    'checkUWIssues': (uwIssues) => checkUWIssues(uwIssues),
    'onWithdraw': (submissionVM, showConfirm, showAlert, translator, history, authHeader) => onWithdraw(submissionVM, showConfirm, showAlert, translator, history, authHeader),
    'onReferToUnderwriter': (submissionVM, formData, history, setShowReferToUW, showAlert, authHeader) => onReferToUnderwriter(submissionVM, formData, history, setShowReferToUW, showAlert, authHeader),
    'saveExit': (submissionVM, showConfirm, history, authHeader) => saveExit(submissionVM, showConfirm, history, authHeader),
    'hasUWBlockingIssues': (uwIssues) => hasUWBlockingIssues(uwIssues),
    'premiumContinueVisibility': (uwIssues) => premiumContinueVisibility(uwIssues),
};
